var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShStoreSolid(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14.14 13.572"
    }, props),
    React.createElement("path", { d: "M13.819 3.144L12.329.4a.718.718 0 00-.622-.4H2.432a.718.718 0 00-.622.4L.32 3.144C-.449 4.562.233 6.534 1.67 6.76a2.071 2.071 0 00.315.024 2.149 2.149 0 001.694-.877 2.152 2.152 0 001.694.877 2.149 2.149 0 001.694-.877 2.074 2.074 0 003.388 0 2.156 2.156 0 001.694.877 2.049 2.049 0 00.315-.024c1.442-.223 2.126-2.195 1.354-3.616zm-1.665 4.49a2.546 2.546 0 01-.677-.1v2.646H2.662V7.534a2.658 2.658 0 01-.677.1 2.689 2.689 0 01-.413-.034 2.559 2.559 0 01-.376-.1v5.217a.8.8 0 00.735.848h10.283a.8.8 0 00.73-.841V7.507a2.078 2.078 0 01-.376.1 2.772 2.772 0 01-.418.032z" })
  );
}

export default SvgShStoreSolid;